<template>
  <v-dialog
    v-model="showDialog"
    max-width="660"
    @click:outside="cancelDialog"
    content-class="create-template-dialog"
  >
    <v-card>
      <v-card-title>
        <h3>Create Template</h3>
      </v-card-title>

      <v-card-text v-if="details.Status.toLowerCase() !== 'stopped'">
        <p>
          It's recommented to stop environment before creating the template.
        </p>
      </v-card-text>

      <v-text-field
        v-model="templateName"
        label="Template name"
        name="snapshotName"
        type="text"
        maxlength="128"
        class="ml-8 mr-8"
        :error-messages="
          !$v.templateName.validateTemplateName
            ? 'Invalid character in template name'
            : null
        "
      ></v-text-field>
      <v-combobox
        v-model="selectedRegions"
        class="ml-8 mr-8 mb-4"
        :items="computedRegions"
        item-text="regionName"
        item-value="Id"
        append-icon="fas fa-caret-down"
        chips
        multiple
        fixed
        hint="Select Regions"
        persistent-hint
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 2">
            <span>{{ item.regionName }}</span>
          </v-chip>

          <span v-if="index === 2" class="grey--text caption"
            >(+{{ selectedRegions.length - 2 }} others)</span
          >
        </template>
      </v-combobox>
      <v-card-actions class="justify-center buttons">
        <v-btn text @click="cancelDialog">Cancel</v-btn>

        <v-btn
          color="success darken-1"
          @click="confirmDialog"
          :disabled="
            loading ||
            !$v.templateName.required ||
            !$v.templateName.maxLength ||
            !$v.templateName.minLength ||
            !$v.templateName.validateTemplateName
          "
        >
          <v-icon left v-if="loading">fas fa-spinner fa-spin</v-icon>
          <v-icon left v-else>fas fa-plus-circle</v-icon>Create template
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

export default {
  data: () => ({
    templateName: "",
    loading: false,
    selectedRegions: [],
    defaultRegion: [],
  }),
  props: ["showCreateTemplateDialog", "details"],
  watch: {
    showCreateTemplateDialog() {
      this.loading = false;
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.showCreateTemplateDialog;
      },
      set(value) {
        this.$emit("update:showCreateTemplateDialog", value);
      },
    },
    computedRegions() {
      const result = this.details.allRegions
        .map((item) => {
          const { Id, DisplayName } = item;
          return {
            id: Id,
            regionName: DisplayName,
            disabled: this.details.DisplayName === DisplayName,
          };
        })
        .sort(
          (a, b) =>
            b.disabled - a.disabled || a.regionName.localeCompare(b.regionName)
        );

      this.findDefaultRegion(result);
      return result;
    },
  },
  mixins: [validationMixin],
  validations: {
    templateName: {
      required,
      maxLength: maxLength(128),
      minLength: minLength(3),
      validateTemplateName() {
        const regex = /^[ A-Za-z0-9_\[\]'.()@/-]*$/g;
        return this.templateName.match(regex) ? true : false;
      },
    },
  },
  methods: {
    findDefaultRegion(obj) {
      this.defaultRegion = obj.filter(
        (x) => x.regionName === this.details.DisplayName
      );
      this.selectedRegions = this.defaultRegion;
    },

    cancelDialog() {
      this.showDialog = false;
      this.templateName = "";
      this.selectedRegions = this.defaultRegion;
    },

    confirmDialog() {
      this.loading = true;

      const data = {
        environmentId: this.details.Id,
        templateName: this.templateName,
        regionIds: this.selectedRegions.map((region) => region.id),
      };

      this.$emit("confirmCreateTemplateDialog", data);
      this.templateName = "";
      this.selectedRegions = this.defaultRegion;
    },
  },
};
</script>

<style scoped>
.create-template-dialog h3,
p,
input,
.snapshot-input {
  font-family: "Montserrat";
  text-align: center;
}

.create-template-dialog h3 {
  margin: 0 auto;
  margin-top: 30px;
  margin-bottom: 30px;
}

.create-template-dialog p {
  font-weight: 500;
}

.create-template-dialog p:nth-child(2) {
  margin-top: -15px;
}

.create-template-dialog .buttons {
  padding-bottom: 60px;
}
</style>